import {FunctionEvalArgument} from 'notebook/tables/excess/FunctionConstants';
import flatten from 'notebook/tables/excess/util/flatten';
import removeNulls from 'util/removeNulls';

/**
 * Filters a list of values into a flat list of numbers.
 */
export default function (values: Array<FunctionEvalArgument>): Array<number> {
  return removeNulls(flatten(values).map((value) => (typeof value === 'number' ? value : null)));
}
